import { Swiper } from 'swiper';
import { A11y, Autoplay, EffectFade, Navigation } from 'swiper/modules';

const testimonialCycleBlocks = document.querySelectorAll(
	'.block-testimonial-cycle'
);

if (testimonialCycleBlocks.length) {
	const initSwiper = (block) => {
		const swiperContainer = block.querySelector('.swiper');

		if (!swiperContainer) return;

		const paginationButtons = block.querySelectorAll(
			'.block-testimonial-cycle__swiper-pagination-button'
		);

		const slideDelay = parseInt(
			block.style.getPropertyValue('--slideDelay'),
			10
		);

		const settings = {
			loop: true,
			autoplay: { delay: slideDelay || 3000 },
			slidesPerView: 1,
			effect: 'fade',
			fadeEffect: { crossFade: true },
			speed: 100,
			modules: [A11y, Autoplay, EffectFade, Navigation],
			navigation: {
				prevEl: block.querySelector('.swiper-button-prev'),
				nextEl: block.querySelector('.swiper-button-next'),
			},
			breakpoints: {
				768: {
					speed: 400,
				},
			},
		};

		const swiperInstance = new Swiper(swiperContainer, settings);

		paginationButtons[0].classList.add('active');

		swiperInstance.on('slideChangeTransitionEnd', (swiper) => {
			paginationButtons.forEach((btn) => {
				btn.classList.toggle(
					'active',
					Number(btn.dataset.index) === swiper.realIndex
				);
			});
		});

		paginationButtons.forEach((button) => {
			button.addEventListener('click', (e) => {
				const nextIndex = button.getAttribute('data-index');
				if (!nextIndex) return;

				swiperInstance.slideToLoop(nextIndex);
				swiperInstance.autoplay.stop();
				block.classList.add('autoplay-paused');

				e.preventDefault();
			});
		});
	};

	const observer = new IntersectionObserver(
		(entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				observer.unobserve(entry.target);
				initSwiper(entry.target);
			});
		},
		{ rootMargin: '200px 0px' }
	);

	testimonialCycleBlocks.forEach((block) => observer.observe(block));
}
